'use client';
import React, { createContext, useState } from 'react';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { Tabs } from '@/shared/components';
import { BulkUpload } from './bulk-upload';
import { ManualEntry } from './manual-entry';
import { usePageTracking } from '@/shared/tracking/use-tracking';
import { useIsClient } from '@/hooks/use-is-client';

export interface ContextProps {
  skuData?: any;
  setSkuData?: any;
  skuMethod?: any;
}
export const BulkUploadContext = createContext<ContextProps>({});
export default function QuickOrder() {
  const { t } = useLang(NAMESPACE.quickOrder);
  const isClient = useIsClient();
  const [defaultIndex, setDefaultIndex] = useState(0);
  const [skuData, setSkuData] = useState([]);
  const [skuMethod, setSkuMethod] = useState({});
  const manual_entry_title = (
    <div className="flex">
      <span className="pt-1 pr-2">
        <i className="icon-24-table-mono"></i>
      </span>
      <div className="text-justify">
        <p className="text-lg font-medium">{t('manual.entry')}</p>
        <p>{t('enter.items')}</p>
      </div>
    </div>
  );
  const bulk_upload_title = (
    <div className="flex">
      <span className="pt-1 pr-2">
        <i className="icon-24-upload-mono"></i>
      </span>
      <div className="text-justify">
        <p className="text-lg font-medium">{t('bulk.upload')}</p>
        <p>{t('upload.items')}</p>
      </div>
    </div>
  );
  const bulkUpdateFunc = (sku) => {
    setDefaultIndex(0);
    const skuMethods = { ...skuMethod };
    sku.map((item) => {
      skuMethods[item.childSku] = 'quickorderbulkupload';
    });
    setSkuMethod(skuMethods);
    const updatedData = [...skuData, ...sku];
    setSkuData(updatedData);
  };
  const manualUpdateFunc = (sku) => {
    const skuMethods = { ...skuMethod };
    sku.map((item) => {
      if (!skuMethods[item.childSku]) {
        skuMethods[item.childSku] = 'quickordermanualentry';
      }
    });
    setSkuMethod(skuMethods);
    setSkuData(sku);
  };
  const tabData = [
    { title: manual_entry_title, content: <ManualEntry manualDataFunc={manualUpdateFunc} /> },
    { title: bulk_upload_title, content: <BulkUpload bulkUpdateFunc={bulkUpdateFunc} /> },
  ];
  const handleChange = (event, newValue) => {
    setDefaultIndex(newValue);
  };
  usePageTracking();
  return (
    <BulkUploadContext.Provider value={{ skuData, skuMethod }}>
      <div className="grid grid-cols-[1fr_345px] w-full">
        <div className="col-span-2 mt-8 w-full mb-5">
          <h1 className="font-medium">{t('title')}</h1>
        </div>
        <div className="col-span-2 grid">
          {isClient && <Tabs tabContent={tabData} handleChange={handleChange} defaultIndex={defaultIndex} />}
        </div>
      </div>
    </BulkUploadContext.Provider>
  );
}
